import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { IntlProvider } from "react-intl";
import messages_es from "./translations/es.json";
import messages_en from "./translations/en.json";
import messages_ca from "./translations/ca.json";
import LocalStorageManager, { LANGUAGE_ID } from "./components/screen/LocalStorageManager";

const messages = {
    'es': messages_es,
    'en': messages_en,
    'ca': messages_ca
}

let language = LocalStorageManager.getLanguage();
if (!language) {
    language = navigator.language.split(/[-_]/)[0];  // language without region code
    LocalStorageManager.setLanguage(language as LANGUAGE_ID);
}

// LocalStorageManager.setShowCovidBalloon(LocalStorageManager.getShowCovidBalloon());

const rootElement = document.getElementById("root");
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);

    root.render(
        <React.StrictMode>
            {/* @ts-ignore */}
            <IntlProvider key={language} locale={language} messages={messages[language]}>
                <App />
            </IntlProvider>
        </React.StrictMode>,
    );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
